/**
 * Vue global helper functions
 */
import helpers from '@/helpers';

export const plugin = {
    name: 'helpers',

    pluginProperties: {
        helpers
    },

    install (Vue) {
        Vue.prototype.$helpers = helpers;
    }
};

export default plugin;
